import mixpanel from 'mixpanel-browser'

export const messageSentTracking = (riderId, ownerId, bikeId, message) => {
  mixpanel.track('Chat message sent.', {
    rider_id: riderId,
    owner_id: ownerId,
    bike_id: bikeId,
    message: message,
  })
}
